import { Component } from "react";
import PropTypes from "prop-types";
import get from "lodash/get";

import eventBus from "@src/helpers/events";
import { asosGlobalNamespace } from "@template/constants";

import { initialiseSecuredTouch } from "./securedTouchSDKInitialisation";

const SECUREDTOUCH_INITIAL_SCRIPT_URL =
  "https://static.securedtouch.com/sdk/st-ping-1.1.0p.js?appId=asos-qa&sessionId=d64ab43e07b94ceb85f5366b544ec6fb";
const SECUREDTOUCH_SDK_SCRIPT_URL =
  "https://static.securedtouch.com/sdk/securedtouch-sdk-3.7.3w.js";

const loadScript = scriptUrl => {
  const script = document.createElement("script");
  script.src = scriptUrl;
  script.defer = true;
  document.body.appendChild(script);
};

const identityReadyHandler = () => {
  global[asosGlobalNamespace].sdk.identity.customer
    .profile()
    .then(function(response) {
      const { sessionId } = response;
      const customerGuid = response.isAuthenticated
        ? response.customerGuid
        : null;
      initialiseSecuredTouch(customerGuid, sessionId);
    });
};

class SecuredTouch extends Component {
  static propTypes = {
    securedTouchEnabled: PropTypes.bool
  };

  componentDidMount() {
    const { securedTouchEnabled } = this.props;

    if (securedTouchEnabled) {
      loadScript(SECUREDTOUCH_INITIAL_SCRIPT_URL);
      loadScript(SECUREDTOUCH_SDK_SCRIPT_URL);

      if (get(global[asosGlobalNamespace], "sdk.identity")) {
        identityReadyHandler();
      } else {
        eventBus.addListener("identity-sdk-ready", identityReadyHandler);
      }
    }
  }
  render() {
    return null;
  }
}

export default SecuredTouch;
